// extracted by mini-css-extract-plugin
export var wordContainer = "_pp-0";